// @flow
import { closeSnackbar, MaterialDesignContent, SnackbarProvider } from "notistack";
import { Button, styled, useTheme } from "@mui/material";
import React from "react";
import CheckIcon from "../../../assets/images/icons/interfase/checkIcon";
import CloseMenuIcon from "../../../assets/images/icons/menu/closeMenuIcon";
import InfoIcon from "../../../assets/images/icons/warning/infoIcon";
import StopSignIcon from "../../../assets/images/icons/warning/stopSignIcon";

type Props = {};

const SnackbarProviderExtended = (props: Props) => {
	const theme = useTheme();
	const { primary, info, warning, success, error } = theme.palette;
	
	const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
		'&.notistack-MuiContent-success': {
			borderRadius: '12px',
			backgroundColor: success.lighter,
			// fontWeight: 'bold',
			color: primary[800],
			borderLeft: `3px solid ${success.main}`
		},
		'&.notistack-MuiContent-warning': {
			borderRadius: '12px',
			backgroundColor: warning.lighter,
			// fontWeight: 'bold',
			color: primary[800],
			borderLeft: `3px solid ${warning.main}`
		},
		'&.notistack-MuiContent-error': {
			borderRadius: '12px',
			backgroundColor: error.lighter,
			// fontWeight: 'bold',
			color: primary[800],
			borderLeft: `3px solid ${error[600]}`
		},
		'&.notistack-MuiContent-info': {
			borderRadius: '12px',
			backgroundColor: info[100],
			color: primary[800],
			borderLeft: `3px solid ${info.main}`
		},
	}));
	return (
		<SnackbarProvider
			maxSnack={8}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			Components={{
				success: StyledMaterialDesignContent,
				error: StyledMaterialDesignContent,
				warning: StyledMaterialDesignContent,
				info: StyledMaterialDesignContent
			}}
			iconVariant={{
				success: <CheckIcon color={success.main}/>,
				error: <StopSignIcon color={error[600]}/>,
				warning: <InfoIcon color={warning.main}/>,
				info: <InfoIcon color={info.main}/>
			}}
			dense={true}
			autoHideDuration={4000}
			preventDuplicate={true}
			action={(snackbarId) => (
				<Button
					variant={'text'}
					onClick={() => closeSnackbar(snackbarId)}
					sx={{padding: 0}}
				>
					<CloseMenuIcon
						color={primary[800]}
					/>
				</Button>
			)}
		>
			{props.children}
		</SnackbarProvider>
	);
};

export default SnackbarProviderExtended